import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { MainLayout } from './layouts/MainLayout';
import { Home } from './pages/Home';
import { Auth } from './containers/Auth';
import { AuthProvider } from './contexts/AuthContext';
import { EmailVerification } from './components/EmailVerification';
import Setlist from './components/Setlist';
import { Admin } from './pages/Admin';
import { PrivateRoute } from './components/PrivateRoute';
import { SetlistSimulationService } from './components/SetlistSimulationService';

function App() {
  const [authView, setAuthView] = useState('signup'); // Start with signup form

  const handleAuthViewChange = (view) => {
    if (view === null || view === undefined) {
      setAuthView('signup');
      return;
    }
    setAuthView(view);
  };

  return (
    <Router>
      <AuthProvider>
        {/* Automatic setlist simulation service - runs in background */}
        <SetlistSimulationService />
        
        <Routes>
          <Route path="/" element={<MainLayout onAuthViewChange={handleAuthViewChange}>
            {!authView && <Home />}
            {authView && <Auth initialView={authView} />}
          </MainLayout>} />
          <Route path="/finalize-signup" element={<EmailVerification />} />
          <Route path="/setlist" element={
            <PrivateRoute>
              <MainLayout>
                <Setlist />
              </MainLayout>
            </PrivateRoute>
          } />
          <Route path="/admin" element={
            <MainLayout>
              <Admin />
            </MainLayout>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
